import React, { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useEffectOnce } from 'react-use';
import { CollectionType } from '../../data-layer/collections/service';
import { CollectionCard } from '../../ui/users/CollectionCard';
import { CollectionsGrid } from '../../ui/users/CollectionsGrid';
import { UserCollectionsTabs as Tabs } from './UserCollectionsTabs';
import { useCollectionsController } from './useCollectionsController';
import { withCollectionCallbacks } from './withCollectionCallbacks';

const EnhancedCollectionCard = withCollectionCallbacks(CollectionCard);

export function UserCollections() {
    const { savedCollections, createdCollections, isLoading, loadCollections } =
        useCollectionsController();
    const [query, setQuery] = useSearchParams();

    const collectionType = (
        query.get('collectionType') === CollectionType.SAVED
            ? CollectionType.SAVED
            : CollectionType.CREATED
    ) as CollectionType;

    useEffect(() => {
        const needChangeQuery = Boolean(
            !isLoading &&
                !savedCollections.length &&
                createdCollections.length &&
                createdCollections[0] &&
                collectionType !== CollectionType.CREATED,
        );

        if (needChangeQuery) {
            setQuery({ collectionType: CollectionType.CREATED }, { replace: true });
        }
    }, [
        collectionType,
        createdCollections,
        createdCollections.length,
        isLoading,
        savedCollections.length,
        setQuery,
    ]);

    useEffectOnce(() => {
        loadCollections();
    });

    const onChangeTab = (type: CollectionType) => {
        setQuery({ collectionType: type }, { replace: true });
    };

    const currentCollection =
        collectionType === CollectionType.SAVED ? savedCollections : createdCollections;

    return (
        <>
            {savedCollections.length ? (
                <Tabs collectionType={collectionType} onChange={onChangeTab} />
            ) : null}
            <CollectionsGrid
                collections={currentCollection}
                isLoading={isLoading}
                renderItem={(index) => (
                    <EnhancedCollectionCard
                        key={currentCollection[index].id}
                        collection={currentCollection[index]}
                        isSaved={currentCollection[index].isSaved}
                        isOwner={!currentCollection[index].isSaved}
                    />
                )}
            />
        </>
    );
}
